import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private httpClient: HttpClient) { }

  bmiCalculator(bmiData: any): Observable<any>{
    return this.httpClient.post('/api/users/bmi', bmiData)
      .pipe(res => res);
  }

  checkFreeDietEligibility():Observable<any>{
    return this.httpClient.get('/api/users/check_free_diet_eligibility');
  }

  getOrganizationPages():Observable<any>{
    return this.httpClient.get(`/api/organization/organization_pages`);
  }

  checkOnboardingForm(reqObj):Observable<any>{
    return this.httpClient.post(`/api/dynamicForms/check_onboarding_form`, reqObj);
  }
  checkHealthProgressForm():Observable<any>{
    return this.httpClient.get(`/api/dynamicForms/check_health_progress_form`);
  }
  getBookmarks():Observable<any>{
    return this.httpClient.get(`/api/organization/bookmark_urls`);
  }

}
